// ---------- shapes alphabet ----------
// 0 empty · 1 full · 2 bottom · 3 top · 4 left · 5 right
// 6 diag bottom-left · 7 diag bottom-right · 8 diag top-left · 9 diag top-right
//
// Le dessin seulement : la conversion d'une image vers ces codes est dans motifs.encode.ts,
// que le jeu n'importe jamais (cf. types.ts).

import { inkColor } from '../ink';
import type { Alphabet } from './types';

export function shapePath(
  ctx: CanvasRenderingContext2D,
  X: number,
  Y: number,
  S: number,
  shape: number,
  frac = 0.5,
): void {
  ctx.beginPath();
  switch (shape) {
    case 1:
      ctx.rect(X, Y, S, S);
      break; // full
    case 2:
      ctx.rect(X, Y + S * (1 - frac), S, S * frac);
      break; // bottom
    case 3:
      ctx.rect(X, Y, S, S * frac);
      break; // top
    case 4:
      ctx.rect(X, Y, S * frac, S);
      break; // left
    case 5:
      ctx.rect(X + S * (1 - frac), Y, S * frac, S);
      break; // right
    case 6:
      ctx.moveTo(X, Y);
      ctx.lineTo(X, Y + S);
      ctx.lineTo(X + S, Y + S);
      ctx.closePath();
      break;
    case 7:
      ctx.moveTo(X + S, Y);
      ctx.lineTo(X + S, Y + S);
      ctx.lineTo(X, Y + S);
      ctx.closePath();
      break;
    case 8:
      ctx.moveTo(X, Y);
      ctx.lineTo(X + S, Y);
      ctx.lineTo(X, Y + S);
      ctx.closePath();
      break;
    case 9:
      ctx.moveTo(X, Y);
      ctx.lineTo(X + S, Y);
      ctx.lineTo(X + S, Y + S);
      ctx.closePath();
      break;
    default:
      ctx.rect(X, Y, S, S); // 0: whole cell (useful for hatching)
  }
}

/** Clockwise sectors from the right -> shape: the half-cell that points that way. Exported
 *  because `motifsTrait` builds its own geometry from it rather than restating it. */
export const SECTOR = [5, 7, 2, 6, 4, 8, 3, 9];

export const motifs: Alphabet = {
  id: 'motifs',
  sheetMode: 'checker',
  bakesOnTop: true,
  label: 'Motifs',
  symbolName: 'motif',
  helpText:
    "La grille prend le format de l'image (aucun rognage) et chaque case pioche un motif : " +
    '<b>couverture</b> = luminosité, <b>orientation</b> = contours. Active <b>Détourer le fond</b> ' +
    'dans les réglages pour les portraits sur fond uni.',

  aspect: () => 1,

  // The full cell is the whole dark mass of the subject — its silhouette. Numbered 1, it used
  // to open the row and every sheet locked onto it: the game handed over the answer and asked
  // you to sweep. Last, the row starts on the half-cells, which say far less on their own.
  paletteOrder: [2, 3, 4, 5, 6, 7, 8, 9, 1],

  draw(ctx, x, y, w, h, code) {
    if (!code) return;
    ctx.fillStyle = inkColor();
    shapePath(ctx, x, y, Math.min(w, h), code);
    ctx.fill();
  },

  // a shape glued to the swatch's edges is illegible: it needs breathing room
  swatch(ctx, w, h, code) {
    motifs.draw(ctx, 3, 3, Math.min(w, h) - 6, Math.min(w, h) - 6, code);
  },
};
